import React from "react";
import {prompts} from "../prompts/money";
import CardPrompter from "./CardPrompter";


export default function Money() {

    return (
        <>
            <header>
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <h1 className="text-3xl font-bold tracking-tight text-gray-900 text-center">
                        Let's Talk About Money
                    </h1>
                </div>
            </header>
            <main>
                <CardPrompter prompts={prompts} bgColour="bg-blue-950"/>
            </main>
        </>
    );
}
